<template lang="html">
	<div class="patrimonial-form">
		<form class="form-ui landscape-patrimonial-ui" novalidate>
			<div class="ctn-toggle row">
				<div class="label">
					Avez-vous des crédits en cours ?
				</div>
				<custom-toggle :value="isCredits" @change="isCredits=$event"/>
			</div>
			<div v-if="isCredits">
				<div class="form-elem-container ctn-toggle row">
					<div class="label">
						Quel est le pourcentage de votre taux d’endettement global selon vous ?
					</div>
					<div class="ctn-input">
						<input v-validate="'required'" type="text" size=10 name="overallDebtPercentage" v-model="overallDebtPercentage" style="width: 150px; border: 1px solid var(--input-grey);">&nbsp;%
					</div>
				</div>
				<div class="ctn-add-children ctn-toggle row">
					<div class="label">
						Quels sont vos crédits en cours ?
					</div>
					<div class="select-btn-container">
						<custom-select :solo="true" :items="typeOfLoan" :selected="currentLoanType" @change="currentLoanType=$event"/>
						<div class="btn-add" @click="addLoan">
							<span class="icon-form-plus"></span>
						</div>
					</div>
				</div>
				<div class="ctn-childrens">
					<div class="ctn-children" v-for="(child, key) in loans" v-bind:key="key">
						<div class="type-children row">
							{{ child.type }} {{ key + 1}} <div class="link" @click="removeLoan(key)">supprimer</div>
						</div>
						<div class="form-elem-container row">
							<div class="ctn-input ctn-label three" :class="{error: errors.has('capital restant' + (key + 1))}">
								<label :for="'capital restant' + (key + 1)">Capital restant dû</label>
								<input v-validate="'required'" type="text" :name="'capital restant' + (key + 1)" v-model="child.value" :key="'amount' + key">
								<custom-select :items="currencies" :selected="child.currency" @change="child.currency=$event" />
							</div>
							<div class="error-message">{{ errors.first('capital restant' + (key + 1))}}</div>
						</div>
						<div class="form-elem-container row">
							<div class="ctn-input ctn-label three" :class="{error: errors.has('mensualité' + (key + 1))}">
								<label :for="'mensualité' + (key + 1)">Mensualité</label>
								<input v-validate="'required'" type="text" :name="'mensualité' + (key + 1)" v-model="child.monthlyPayment" :key="'monthly' + key">
								<custom-select :items="currencies" :selected="child.currency" @change="child.currency=$event" />
							</div>
							<div class="error-message">{{ errors.first('mensualité' + (key + 1))}}</div>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import CustomSelect from '@/common/components/Form/CustomSelect'
import CustomToggle from '@/common/components/Form/CustomToggle'
import Currency from '@/common/components/MyPatrimonialLandscape/data/Currency'
import Loans from '@/common/components/MyPatrimonialLandscape/data/Loans'
import { mapGetters } from 'vuex'

class Loan {
	constructor (type) {
		this.type = type
		this.value = null
		this.monthlyPayment = null
		this.currency = 'EUR'
	}
}

export default {
	name: 'Credits',
	components: {
		CustomSelect,
		CustomToggle
	},
	data () {
		return {
			currencies: Currency,
			typeOfLoan: Loans,
			isCredits: false,
			overallDebtPercentage: null,
			currentLoanType: Loans[0],
			loans: []
		}
	},
	methods: {
		initializeCredits () {
			this.loans = this.$iRobot.arrayClone(this.estate.credits)
			this.isCredits = (this.loans.length > 0)
		},
		addLoan () {
			this.loans = this.loans.concat(new Loan(this.currentLoanType))
		},
		removeLoan (key) {
			this.loans.splice(key, 1)
		},
		validate () {
			return this.$validator.validate()
		},
		refreshDataSaved () {
			setTimeout(() => {
				this.initializeCredits()
			}, 10000)
		},
		save () {
			return new Promise((resolve, reject) => {
				this.validate().then((validation) => {
					if (validation) {
						this.$store.dispatch('storePatrimonial', {
							name: 'CREDITS',
							data: {
								loans: this.loans,
								overallDebtPercentage: this.overallDebtPercentage
							},
							fromStart: false
						}).then(() => {
							resolve()
							this.refreshDataSaved()
						})
					}
				})
			})
		}
	},
	mounted () {
		this.overallDebtPercentage = this.estate.overallDebtPercentage
		console.log('estate', this.estate)
		this.initializeCredits()
	},
	beforeDestroy () {
		this.save()
	},
	computed: {
		...mapGetters({
			estate: 'estate'
		})
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/common/components/MyPatrimonialLandscape/Credits.vue